import {
    PROFILE_RESET_PERFORMANCE_STATS,
    PROFILE_RESET_VOLUMETRIC_STATS,
    PROFILE_GET_PERFORMANCE_STATS,
    PROFILE_GET_PERFORMANCE_STATS_SUCCESS,
    PROFILE_GET_PERFORMANCE_STATS_FAILURE,
    PROFILE_GET_PERFORMANCE_STATS_OVERVIEW,
    PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_SUCCESS,
    PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_FAILURE,
    PROFILE_GET_PTS_PLAYER_RANKING_REQUEST,
    PROFILE_GET_PTS_PLAYER_RANKING_SUCCESS,
    PROFILE_GET_PTS_PLAYER_RANKING_FAILURE,
} from '../actions/actionTypes/profile-action-types';

const initialState = {
    gameType: 'singles',
    year: 'last',
    eventScheduleType: 'upcoming',
    playerId: null,
    isLoading: false,
    results: {},
    data: {},
    isProfileLoaded: false,
    statsState: {
        type: 'singles',
        resultType: 'verified',
        months: 12,
        fetchAllResults: true,
        loading: true,
        completed: false,
        successful: false,
        errorMessage: null,
    },
    stats: {},
    error: null,
    metaData: {},
    isMetadataLoading: false,
    isMetadataLoaded: false,
    rankings: {},
    ptsRankings: {},
    ptsRankingsState: {
        loading: true,
        loaded: false,
        error: null,
        playerId: null,
    },
    localizedRankings: {
        isLoading: false,
    },
    profileViews: {},
    profileViewsState: {
        loading: true,
        complete: false,
        successful: false,
    },
    volumetricStats: {
        isLoading: false,
        data: null,
        error: null,
    },
    volumetricStatsOverview: {
        isLoading: false,
        data: null,
    },
    performanceStats: {
        isLoading: false,
        data: null,
        error: null,
    },
    performanceStatsOverview: {
        isLoading: false,
        hasLoaded: false,
        data: null,
        error: null,
    },
};

function profileReducer(state = initialState, action) {
    switch (action.type) {
        case 'PROFILE:SET_PLAYER_ID':
            return {
                ...state,
                playerId: action.playerId,
                isLoading: true,
                isProfileLoaded: false,
                gameType: 'singles',
                year: 'last',
                results: {},
                rankings: {},
                statsState: state.playerId !== action.playerId
                    ? { ...initialState.statsState }
                    : state.statsState,
                volumetricStats: { isLoading: false, data: null, error: null },
                volumetricStatsOverview: { isLoading: false, data: null },
                performanceStats: { isLoading: false, data: null, error: null },
                performanceStatsOverview: { isLoading: false, hasLoaded: false, data: null, error: null },
            };

        case 'PROFILE:FETCH_REQUEST':
            return {
                ...state,
                error: null,
                isLoading: true,
                isProfileLoaded: false,
            };
        case 'PROFILE:FETCH_SUCCESS': {
            return {
                ...state,
                error: null,
                isLoading: false,
                isProfileLoaded: true,
                data: {
                    ...state.data,
                    ...action.data,
                    clubs: state.data.clubs,
                    clubsRecent: state.data.clubsRecent,
                    tmsEvents: state.data.tmsEvents,
                    tmsEventsRecent: state.data.tmsEventsRecent,
                    tmsEventsUpcoming: state.data.tmsEventsUpcoming,
                    rankings: action?.data?.playerBio?.playerRankings,
                },
            };
        }
        case 'PROFILE:FETCH_FAILURE':
            return {
                ...state,
                error: action.error,
                isLoading: false,
            };
        case 'PROFILE:CHANGE_GAME_TYPE':
            return {
                ...state,
                gameType: action.gameType,
                year: 'last',
            };
        case 'PROFILE:CHANGE_YEAR':
            return {
                ...state,
                year: action.year,
            };
        case 'PROFILE:CHANGE_EVENT_SCHEDULE_TYPE':
            return {
                ...state,
                eventScheduleType: action.scheduleType,
            };
        case 'PROFILE:SAVE_PROFILE':
            return {
                ...state,
                isLoading: true,
            };
        case 'PROFILE:SAVE_PROFILE_SUCCESS':
        case 'PROFILE:SAVE_PROFILE_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'PROFILE:CROP_PROFILE_PHOTO_SUCCESS':
            return {
                ...state,
                data: {
                    ...state.data,
                    profileImage: action.res.data.photoUrl,
                    playerProfileImages: {
                        default: action.res.data.photoUrl,
                    },
                },
            };
        case 'PROFILE:REMOVE_PROFILE_PHOTO_SUCCESS':
            return {
                ...state,
                data: {
                    ...state.data,
                    profileImage: null,
                    playerProfileImages: null,
                },
            };
        case 'PROFILE:CROP_BANNER_PHOTO_SUCCESS':
            return {
                ...state,
                data: {
                    ...state.data,
                    bannerImage: action.res.data.bannerUrl,
                },
            };
        case 'PROFILE:REMOVE_BANNER_PHOTO_SUCCESS':
            return {
                ...state,
                data: {
                    ...state.data,
                    bannerImage: null,
                },
            };
        case 'PROFILE:FETCH_METADATA_REQUEST':
            return {
                ...state,
                metaData: {},
                isMetadataLoading: true,
            };
        case 'PROFILE:FETCH_METADATA_SUCCESS':
            return {
                ...state,
                metaData: action.data,
                isMetadataLoading: false,
            };
        case 'PROFILE:FETCH_METADATA_FAILURE':
            return {
                ...state,
                metaData: {},
                isMetadataLoading: false,
            };
        case 'PROFILE:UPDATE_STATS_PARAMS':
            return {
                ...state,
                statsState: {
                    ...(state.statsState),
                    ...(action.data.params),
                },
            };
        case 'PROFILE:FETCH_PLAYER_STATS':
            return {
                ...state,
                statsState: {
                    ...(state.statsState),
                    loading: true,
                    completed: false,
                    successful: false,
                    errorMessage: null,
                },
                stats: {},
                playerId: action.data.playerId,
            };
        case 'PROFILE:FETCH_PLAYER_STATS_SUCCESS':
            return {
                ...state,
                statsState: {
                    ...(state.statsState),
                    loading: false,
                    completed: true,
                    successful: true,
                    errorMessage: null,
                },
                stats: action.data.stats,
            };
        case 'PROFILE:FETCH_PLAYER_STATS_FAILURE':
            return {
                ...state,
                statsState: {
                    ...(state.statsState),
                    loading: false,
                    completed: true,
                    successful: false,
                    errorMessage: 'could not fetch player stats',
                },
                stats: {},
            };
        case 'PROFILE:FETCH_STUDENT_REQUEST':
            return {
                ...state,
                studentState: {
                    loading: true,
                    complete: false,
                    successful: false,
                    errorMessage: null,
                },
            };
        case 'PROFILE:FETCH_STUDENT_FAILURE':
            return {
                ...state,
                data: {
                    ...state.data,
                    studentInfo: {},
                },
                studentState: {
                    loading: false,
                    complete: true,
                    successful: false,
                    errorMessage: 'Failed to retrieve student info',
                },
            };
        case 'PROFILE:FETCH_STUDENT_SUCCESS':
            return {
                ...state,
                data: {
                    ...state.data,
                    studentInfo: action.data || {},
                },
                studentState: {
                    loading: false,
                    complete: true,
                    successful: true,
                    errorMessage: null,
                },
            };
        case PROFILE_GET_PTS_PLAYER_RANKING_REQUEST:
            return {
                ...state,
                ptsRankingsState: {
                    ...(state.ptsRankingsState),
                    loading: true,
                    loaded: false,
                    error: null,
                    playerId: action.playerId,
                },
                ptsRankings: {},
            };
        case PROFILE_GET_PTS_PLAYER_RANKING_SUCCESS:
            return {
                ...state,
                ptsRankingsState: {
                    ...(state.ptsRankingsState),
                    loading: false,
                    loaded: true,
                    error: null,
                },
                ptsRankings: action.data,
            };
        case PROFILE_GET_PTS_PLAYER_RANKING_FAILURE:
            return {
                ...state,
                ptsRankingsState: {
                    ...(state.ptsRankingsState),
                    loading: false,
                    loaded: false,
                    error: 'could not fetch player Ptsranking',
                },
                ptsRankings: {},
            };
        case 'PROFILE:GET_LOCALIZED_RANKINGS':
            return {
                ...state,
                localizedRankings: {
                    isLoading: true,
                    localizedRankings: {},
                },
            };
        case 'PROFILE:GET_LOCALIZED_RANKINGS_SUCCESS':
            return {
                ...state,
                localizedRankings: {
                    isLoading: false,
                    ...action.data,
                },
            };
        case 'PROFILE:GET_LOCALIZED_RANKINGS_FAILURE':
            return {
                ...state,
                localizedRankings: {
                    isLoading: false,
                    localizedRankings: {},
                },
            };
        case 'PROFILE:GET_PROFILE_VIEWS':
            return {
                ...state,
                profileViewsState: {
                    loading: true,
                    complete: false,
                    successful: false,
                },
                profileViews: {},
            };
        case 'PROFILE:GET_PROFILE_VIEWS_SUCCESS':
            return {
                ...state,
                profileViewsState: {
                    ...(state.profileViewsState),
                    loading: false,
                    complete: true,
                    successful: true,
                },
                profileViews: action.res.data,
            };
        case 'PROFILE:GET_PROFILE_VIEWS_FAILURE':
            return {
                ...state,
                profileViewsState: {
                    ...(state.profileViewsState),
                    loading: false,
                    complete: true,
                    successful: false,
                },
                profileViews: {},
            };
        case 'PROFILE:GET_VOLUMETRIC_STATS':
            return {
                ...state,
                volumetricStats: {
                    ...state.volumetricStats,
                    isLoading: true,
                    error: null,
                },
            };
        case 'PROFILE:GET_VOLUMETRIC_STATS_SUCCESS':
            return {
                ...state,
                volumetricStats: {
                    isLoading: false,
                    data: action.data.data,
                    error: null,
                },
            };
        case 'PROFILE:GET_VOLUMETRIC_STATS_FAILURE':
            return {
                ...state,
                volumetricStats: {
                    ...state.volumetricStats,
                    isLoading: false,
                    error: true,
                },
            };
        case PROFILE_RESET_VOLUMETRIC_STATS:
            return {
                ...state,
                volumetricStats: { isLoading: false, data: null, error: null },
            };
        case 'PROFILE:GET_VOLUMETRIC_STATS_OVERVIEW':
            return {
                ...state,
                volumetricStatsOverview: {
                    ...state.volumetricStatsOverview,
                    isLoading: true,
                },
            };
        case 'PROFILE:GET_VOLUMETRIC_STATS_OVERVIEW_SUCCESS':
            return {
                ...state,
                volumetricStatsOverview: {
                    isLoading: false,
                    data: action.data,
                },
            };
        case 'PROFILE:GET_VOLUMETRIC_STATS_OVERVIEW_FAILURE':
            return {
                ...state,
                volumetricStatsOverview: {
                    isLoading: false,
                    data: null,
                },
            };
        case PROFILE_GET_PERFORMANCE_STATS:
            return {
                ...state,
                performanceStats: {
                    ...state.performanceStats,
                    isLoading: true,
                    error: null,
                },
            };
        case PROFILE_GET_PERFORMANCE_STATS_SUCCESS:
            return {
                ...state,
                performanceStats: {
                    isLoading: false,
                    data: action.data,
                    error: null,
                },
            };
        case PROFILE_GET_PERFORMANCE_STATS_FAILURE:
            return {
                ...state,
                performanceStats: {
                    ...state.performanceStats,
                    isLoading: false,
                    error: true,
                },
            };
        case PROFILE_GET_PERFORMANCE_STATS_OVERVIEW:
            return {
                ...state,
                performanceStatsOverview: {
                    ...state.performanceStatsOverview,
                    isLoading: true,
                    error: null,
                },
            };
        case PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_SUCCESS:
            return {
                ...state,
                performanceStatsOverview: {
                    isLoading: false,
                    hasLoaded: true,
                    data: action.data,
                    error: null,
                },
            };
        case PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_FAILURE:
            return {
                ...state,
                performanceStatsOverview: {
                    ...state.performanceStatsOverview,
                    isLoading: false,
                    hasLoaded: true,
                    error: true,
                },
            };
        case PROFILE_RESET_PERFORMANCE_STATS:
            return {
                ...state,
                performanceStats: { isLoading: false, data: null, error: null },
                performanceStatsOverview: { isLoading: false, hasLoaded: false, data: null, error: null },
            };
        default:
            return state;
    }
}

export default profileReducer;
